import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";
import {NumericOperatorType} from "../../../../../../models/numeric-operator";
import {BaseFieldDeterminantComponent} from "./base-field-determinant.component";

@Component({
  selector: "numeric-determinant",
  templateUrl: "./numeric-determinant.component.html",
  styles: [],
})
export class NumericDeterminantComponent extends BaseFieldDeterminantComponent {

  public operators: string[];
  @Input() public operator: NumericOperatorType;
  @Input() public isTargetComponent: boolean;
  @Input() public numericValue: number;
  @Input() public fields: any [] = [];
  @Input() public sourceFormFieldKey: string;

  @Output() public numericValueResponse = new EventEmitter();
  @Output() public operatorResponse = new EventEmitter();

  public ngOnInit() {
    this.operators = Object.keys(NumericOperatorType);
    super.ngOnInit();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.operator && changes.operator.currentValue) {
      this.operator = changes.operator.currentValue;
    }
    if (changes.numericValue && changes.numericValue.currentValue) {
      this.numericValue = changes.numericValue.currentValue;
    }
    if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.type === "number"));
    }
    super.ngOnChanges(changes);
  }

  public numericValueChanged(newValue: number) {
    this.numericValueResponse.emit({numericValue: newValue});
  }

  public operatorValueChanged() {
    this.operatorResponse.emit(this.operator);
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.numericValueResponse.emit({numericValue: this.numericValue, sourceFormFieldKey: this.sourceFormFieldKey});
  }

}
